import { render, staticRenderFns } from "./GroupCreationDialog.vue?vue&type=template&id=42e47159&scoped=true"
import script from "./GroupCreationDialog.ts?vue&type=script&lang=ts&external"
export * from "./GroupCreationDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e47159",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e47159')) {
      api.createRecord('42e47159', component.options)
    } else {
      api.reload('42e47159', component.options)
    }
    module.hot.accept("./GroupCreationDialog.vue?vue&type=template&id=42e47159&scoped=true", function () {
      api.rerender('42e47159', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/dialogs/GroupCreationDialog/GroupCreationDialog.vue"
export default component.exports